import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

import { ShimmerText } from '../../../components';
import {
  ChevronContainer,
  Container,
  GoBackChevron,
  LeftContainer,
  Title,
  TitleContainer,
} from './AuthenticatedLayout.styles';

interface AuthenticatedLayoutProps {
  title?: string | ReactNode;
  children: ReactNode;
  showBack?: boolean;
  onGoBack?: () => void;
  rightButton?: ReactNode;
  loading?: boolean;
  padding?: string;
  containerDesktopPadding?: string;
  containerMobilePadding?: string;
  containerTabletPadding?: string;
  maxWidth?: string;
  noOverflowLayout?: boolean;
  shouldShowSurfaceBackground?: boolean;
}

const AuthenticatedLayout = ({
  title,
  loading = false,
  showBack,
  rightButton,
  onGoBack,
  children,
  padding,
  containerDesktopPadding,
  containerMobilePadding,
  containerTabletPadding,
  maxWidth,
  noOverflowLayout,
  shouldShowSurfaceBackground,
  ...rest
}: AuthenticatedLayoutProps): any => {
  const navigate = useNavigate();

  return (
    <Container
      $maxWidth={maxWidth}
      $desktopPadding={containerDesktopPadding}
      $mobilePadding={containerMobilePadding}
      $tabletPadding={containerTabletPadding}
      $noOverflowLayout={noOverflowLayout}
      $shouldShowSurfaceBackground={shouldShowSurfaceBackground}
      {...rest}
    >
      {title || rightButton || showBack ? (
        <TitleContainer padding={padding}>
          <LeftContainer>
            <>
              {showBack && (
                <ChevronContainer onClick={() => (onGoBack ? onGoBack() : navigate(-1))}>
                  <GoBackChevron />
                </ChevronContainer>
              )}
              {loading ? (
                <ShimmerText $width="8rem" $height="1.5rem" />
              ) : (
                title && (typeof title === 'string' ? <Title>{title}</Title> : title)
              )}
            </>
          </LeftContainer>
          {rightButton || null}
        </TitleContainer>
      ) : (
        <></>
      )}
      {children}
    </Container>
  );
};

export default AuthenticatedLayout;
